// extracted by mini-css-extract-plugin
module.exports = {"ExitModal":"ExitModal_ExitModal__xaMbK","buttonWrapper":"ExitModal_buttonWrapper__1VmW_","cancelButton":"ExitModal_cancelButton__3FyPJ"};